module.exports = __webpack_public_path__ + "img/001_roundandround.63e8c9e9.gif";